import SelectedPharmacy from "assets/images/SelectedPharmacy";
import SelectedPill from "assets/images/SelectedPill";
import SelectedProfile from "assets/images/SelectedProfile";
import pillIcon from "assets/images/pill.svg";
import profileIcon from "assets/images/profile.svg";
import smallPharmacy from "assets/images/small-pharmacy.svg";
import {navLinks as strings} from "strings";

import AppointmentIcon from "components/AppointmentIcon";

type mainNavLink = {
  label: string;
  to: string;
  icon(isActive: boolean, hasUpcoming?: boolean): string | JSX.Element;
};

type secondaryNavLink = {
  label: string;
  to: string;
};

export const mainNavLinks = (appointmentsEnabled: boolean) => {
  let links: mainNavLink[] = [
    {
      label: strings.pharmacy,
      to: "/pharmacy",
      icon: (isActive) => (isActive ? <SelectedPharmacy /> : smallPharmacy),
    },
    {
      label: strings.medications,
      to: "/medications",
      icon: (isActive) => (isActive ? <SelectedPill /> : pillIcon),
    },
    {
      label: strings.profile,
      to: "/profile",
      icon: (isActive) => (isActive ? <SelectedProfile /> : profileIcon),
    },
  ];
  if (appointmentsEnabled) {
    links = [
      ...links.slice(0, 1),
      {
        label: strings.appointments,
        to: "/appointments",
        icon: (isActive, hasUpcoming) => {
          return (
            <AppointmentIcon
              isSelected={isActive}
              hasUpcoming={hasUpcoming ? hasUpcoming : false}
            />
          );
        },
      },
      ...links.slice(1),
    ];
  }

  return links;
};

export const secondaryNavLinks: secondaryNavLink[] = [];
